import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-details',
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.css']
})
export class ViewDetailsComponent implements OnInit {

  menuList:any;
  pageList:any;
  
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='View')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/view-details/view-details.component.ts